import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "userProfilePage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Profile"),
    /*#__PURE__*/_createTextVNode(" Information")
  ]),
  /*#__PURE__*/_createElementVNode("small", null, "Keep track of your information.")
], -1)
const _hoisted_3 = { class: "bodySec" }
const _hoisted_4 = {
  key: 0,
  class: "agencyDatils"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Agency name : ")
const _hoisted_6 = {
  key: 1,
  class: "agencyForm"
}
const _hoisted_7 = { class: "buttonSec" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_10 = { class: "lefts" }
const _hoisted_11 = { class: "imgSec" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "right" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Update Password", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "passwordSec"
}
const _hoisted_17 = { class: "pheader" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, "Update Password", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Update")
const _hoisted_20 = {
  key: 0,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.showEditForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h4", null, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.userProfile?.agency_name), 1),
              _createVNode(_component_EditOutlined, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editagency(_ctx.userProfile?.agency_id))),
                style: { fontSize: '20px' }
              })
            ]),
            _createElementVNode("small", null, _toDisplayString(_ctx.userProfile?.address), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showEditForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_a_row, { gutter: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  sm: 24,
                  md: 16
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, {
                      ref: "formRef",
                      model: _ctx.formState,
                      rules: _ctx.formRules,
                      layout: "vertical",
                      "label-col": _ctx.labelCol,
                      "wrapper-col": _ctx.wrapperCol
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          ref: "agency_name",
                          required: "",
                          label: "Agency Name",
                          name: "agency_name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formState.agency_name,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.agency_name) = $event)),
                              placeholder: "Enter agency name",
                              "allow-clear": "",
                              autocomplete: "off"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_a_form_item, {
                          ref: "address1",
                          required: "",
                          label: "Address Line1",
                          name: "address1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formState.address1,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.address1) = $event)),
                              placeholder: "Enter Address1",
                              "allow-clear": "",
                              autocomplete: "off"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_a_form_item, {
                          ref: "address2",
                          label: "Address Line2",
                          name: "address2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formState.address2,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.address2) = $event)),
                              placeholder: "Enter Address2",
                              "allow-clear": "",
                              autocomplete: "off"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_a_form_item, {
                          ref: "city",
                          label: "City",
                          name: "city"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formState.city,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.city) = $event)),
                              placeholder: "City ",
                              "allow-clear": "",
                              autocomplete: "off"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_a_form_item, {
                          ref: "country",
                          label: "Country",
                          name: "country"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.formState.country,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.country) = $event)),
                              placeholder: "Select Country",
                              "show-search": "",
                              "filter-option": _ctx.filterOption,
                              "allow-clear": ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCountries, (country) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    value: country.name,
                                    key: country.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(country.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "filter-option"])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_a_form_item, {
                          ref: "postal_code",
                          label: "Postcode ",
                          name: "postal_code"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formState.postal_code,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.postal_code) = $event)),
                              placeholder: "Postcode",
                              "allow-clear": "",
                              autocomplete: "off"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                "html-type": "submit",
                                loading: _ctx.updateLoading,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateAgency(_ctx.formState, _ctx.userProfile?.agency_id)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }, 8, ["loading"]),
                              _createVNode(_component_a_button, {
                                class: "cancel",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cancelAgencyEdit()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules", "label-col", "wrapper-col"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_row, { gutter: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 8
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (!_ctx.userProfile?.photo)
                    ? (_openBlock(), _createBlock(_component_a_avatar, {
                        key: 0,
                        size: 117,
                        src: 
                  'https://ui-avatars.com/api/?background=57429d&name=' +
                  'ss' +
                  '&rounded=true&color=ffffff'
                
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  (_ctx.userProfile?.photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.userProfile.photo
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_upload, {
                    "file-list": _ctx.fileList,
                    "onUpdate:file-list": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.fileList) = $event)),
                    name: "file",
                    class: "avatar-uploader",
                    "show-upload-list": false,
                    action: _ctx.uploadUrl,
                    "before-upload": _ctx.beforeUpload,
                    onChange: _ctx.handleChange,
                    headers: _ctx.headers
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        (_ctx.loading)
                          ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                          : (_openBlock(), _createBlock(_component_EditOutlined, { key: 1 }))
                      ])
                    ]),
                    _: 1
                  }, 8, ["file-list", "action", "before-upload", "onChange", "headers"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 16
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_form, {
                  ref: "userFormRef",
                  model: _ctx.userFormModal,
                  rules: _ctx.userFormRules,
                  colon: false,
                  "label-col": _ctx.labelCol,
                  "wrapper-col": _ctx.wrapperCol
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "First Name",
                      required: "",
                      name: "first_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.userFormModal.first_name,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userFormModal.first_name) = $event)),
                          type: "text",
                          placeholder: "",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "Last Name",
                      required: "",
                      name: "last_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.userFormModal.last_name,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userFormModal.last_name) = $event)),
                          type: "text",
                          placeholder: "",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      ref: "email",
                      required: "",
                      label: "Email",
                      name: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "",
                          value: _ctx.userFormModal.email,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userFormModal.email) = $event)),
                          type: "text",
                          "allow-clear": "",
                          autocomplete: "off",
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 512),
                    _createVNode(_component_a_form_item, {
                      ref: "phone",
                      label: "Phone Number",
                      name: "phone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "",
                          value: _ctx.userFormModal.phone,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userFormModal.phone) = $event)),
                          type: "text",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 512),
                    (_ctx.changePassword === false)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "chnPass",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updatePassword()))
                        }, _hoisted_15))
                      : _createCommentVNode("", true),
                    (_ctx.changePassword === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createVNode(_component_a_button, { onClick: _ctx.removePassword }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_CloseCircleFilled)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _createVNode(_component_a_form_item, {
                            label: "Current Password",
                            required: "",
                            name: "current_password"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.userFormModal.current_password,
                                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userFormModal.current_password) = $event)),
                                "allow-clear": "",
                                type: "password"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 24,
                                md: 12
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "Change Password",
                                    required: "",
                                    name: "password"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _ctx.userFormModal.password,
                                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.userFormModal.password) = $event)),
                                        type: "password",
                                        "allow-clear": ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 24,
                                md: 12
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "Confirm Password",
                                    required: "",
                                    name: "password_confirmation"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _ctx.userFormModal.password_confirmation,
                                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.userFormModal.password_confirmation) = $event)),
                                        type: "password",
                                        "allow-clear": ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_form_item, { class: "footers" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onSubmit(_ctx.userFormModal))),
                          loading: _ctx.profileLoading
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules", "label-col", "wrapper-col"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.pageLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}